import { format, parse, formatDistance, differenceInDays } from 'date-fns'
import { uppercaseFirstLetter } from '@/helpers/strings'
import { dateDiffWordsDays } from '@/helpers/dateHelpers'

export const formatLongDate = (
  value: string | undefined | null,
  dateFormat = 'PPPP'
) => {
  if (!value) return ''
  const dateValue: Date = parse(value, 'yyyy-MM-dd', new Date())
  return format(dateValue, dateFormat)
}

export const formatDate = (
  value: string | undefined | null,
  dateFormat = 'PP'
) => {
  if (!value) return ''
  const dateValue: Date = parse(value, 'yyyy-MM-dd', new Date())
  return format(dateValue, dateFormat)
}

export const formatDateDiffWords = (
  value: string | undefined | null,
  compareDate: Date | undefined = undefined
) => {
  if (!value) return ''
  const compareToDate = compareDate ?? new Date().setHours(0, 0, 0, 0)
  const dateValue: Date = parse(value, 'yyyy-MM-dd', new Date())
  return formatDistance(dateValue, compareToDate, { addSuffix: true })
}

export const formatDateDiffWordsDays = (
  value: string | undefined | null,
  compareDate: Date | undefined = undefined
) => {
  if (!value) return ''
  const compareToDate = compareDate ?? new Date().setHours(0, 0, 0, 0)
  const dateValue: Date = parse(value, 'yyyy-MM-dd', new Date())
  const diff = differenceInDays(dateValue, compareToDate)
  return dateDiffWordsDays(diff)
}

export const formatDateTime = (value?: Date, dateTimeFormat = 'PPp') =>
  value === undefined ? '' : format(value, dateTimeFormat)

export const formatUppercaseFirstLetter = (value: string) => {
  if (!value) return ''
  return uppercaseFirstLetter(value.toString())
}

export const formatNumber = (value: number | string, numOfDecimals = 0) => {
  if (!value) return ''
  value = Number(value)
  return value.toLocaleString(undefined, {
    maximumFractionDigits: numOfDecimals,
  })
}
